import { render, staticRenderFns } from "./ExcluirComissao.vue?vue&type=template&id=45f07417&"
import script from "./ExcluirComissao.vue?vue&type=script&lang=ts&"
export * from "./ExcluirComissao.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports